import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=580321de&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "./Default.vue?vue&type=style&index=0&id=580321de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580321de",
  null
  
)

export default component.exports